import { type ReactNode } from 'react';
import { useTransition, animated, config } from '@react-spring/web';
import { useToaster, type Toast } from 'react-hot-toast/headless';

import styles from './QuizToastContainer.module.css';

const QUIZ_TOAST_DURATION = 3000;

interface Props {
  testid?: string;
  duration?: number;
}

interface RenderedToastProps {
  toast: Toast;
}

function RenderedToast(props: RenderedToastProps) {
  const { toast } = props;
  const { visible, ariaProps, id: toastId, message: toastMessage } = toast;
  const transitions = useTransition(visible, {
    config: config.stiff,
    from: {
      transform: `translate3d(0, 100%, 0)`,
      opacity: 0,
    },
    enter: {
      transform: `translate3d(0, 0%, 0)`,
      opacity: 1,
    },
    leave: {
      transform: `translate3d(0, 100%, 0)`,
      opacity: 0,
    },
  });

  return transitions(({ opacity, transform }, item) => {
    if (item === false) {
      return null;
    }

    return (
      <animated.div
        className={styles.toast}
        {...ariaProps}
        style={{ transform, opacity }}
        key={toastId}
      >
        {toastMessage as ReactNode}
      </animated.div>
    );
  });
}

export function QuizToastContainer(props: Props) {
  const { testid } = props;
  const { toasts } = useToaster({
    duration: QUIZ_TOAST_DURATION,
  });

  const body = (
    <div data-testid={testid} className={styles.container}>
      {toasts.map((toast) => {
        return <RenderedToast key={toast.id} toast={toast} />;
      })}
    </div>
  );

  return body;
}
